import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lcd-content" }

import { computed, getCurrentInstance, ref } from "vue";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'LCDReadOnly',
  props: {
    text: {}
  },
  setup(__props: any) {

	const props = __props;
	// let text = props.text;

	// if (typeof text !== "string") {
	//   // @ts-ignore
	//   const el = getCurrentInstance()?.vnode?.props?.data?.id;
	//   console.log("LCDReadOnly: id =", el);
	//   // Oppure passa tu un "id" via props se vuoi!
	//   console.log("window.__lcdTexts =", (window as any).__lcdTexts);
	//   console.log("window.__lcdTexts[el] =", (window as any).__lcdTexts?.[el]);
	//   if ((window as any).__lcdTexts && el && (window as any).__lcdTexts[el]) {
	//     text = (window as any).__lcdTexts[el];
	//   } else {
	//     text = "Caricamento in corso...";
	//   }
	// }
	const inst = getCurrentInstance()!;
	const controlId = inst.vnode.props?.data?.id as string;

	// --- reactive map globale (già popolata da data.vue) ---
	const allTexts = () => (window as any).__lcdTexts || {};

	// --- computed che sceglie fra props.text (prima render) e poi la mappa globale ---
	const displayed = computed(() => {
		if (typeof props.text === "string") {
			return props.text;
		}
		return allTexts()[controlId] || "Caricamento in corso…";
	});
	const hovered = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lcd-readonly", { 'lcd-hover': hovered.value }]),
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hovered.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hovered.value = false))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(displayed.value), 1)
  ], 34))
}
}

})